<template>
  <div class="columns">
    <div class="column">
      <b-field>
        <b-switch
          v-model="componentVisibility"
          :data-cy="`switch-${id}`"
          size="is-small"
          class="mr-2"
          @input.native="onSwitchChange($event.target.checked)" />
        <span class="is-inline-block">
          {{ label }}<br>
          <small>{{ labelDescription }}</small>
        </span>
      </b-field>
      <b-collapse :open="componentVisibility">
        <div v-for="(val, index) in value" :key="index" class="inner is-vcentered" :data-cy="`base-input-${id}`">
          <BaseInput
            v-for="(field, f) in template"
            :id="`bi-${index}-${f}`"
            :key="f"
            v-model="val[field.name]"
            :field="field"
            class="inner-col"
            @input="event => updateInputs(index, event, field.name, field.type)" />
          <div v-if="isArray" class="inner-col">
            <b-button
              v-if="index === 0"
              type="is-text"
              size="is-small"
              rounded
              @click="addInputs()">
              <b-icon icon="plus" />
            </b-button>
            <b-button
              v-else
              type="is-text"
              size="is-small"
              rounded
              @click="removeInputs(index)">
              <b-icon icon="times" />
            </b-button>
          </div>
        </div>
      </b-collapse>
    </div>
  </div>
</template>
<script>
import BaseInput from '@/ui/components/input/BaseInput.vue';

export default {
  name: 'VerifyInputs',
  components: { BaseInput },
  props: {
    id: String,
    label: String,
    labelDescription: String,
    visible: Boolean,
    template: { type: Array },
    value: { type: Array },
    isArray: Boolean
  },
  data() {
    return {
      componentVisibility: this.visible
    };
  },
  watch: {
    visible() {
      this.componentVisibility = this.visible;
    },
    componentVisibility() {
      this.$emit('update:visible', this.componentVisibility);
    }
  },
  methods: {
    addInputs() {
      this.$emit('add-input');
    },
    removeInputs(index) {
      this.$emit('remove-input', index);
    },
    updateInputs(index, value, field, type) {
      const val = this.value;
      switch (type) {
        case 'number':
          val[index][field] = +value;
          if (this.id === 'fixedNonTaxableIncome' && field === 'monthOne') {
            // El backend requiere dos valores adicionales para otros items de ingreso
            val[index].monthTwo = +value;
            val[index].monthThree = +value;
          }
          break;
        case 'switch':
          val[index][field] = value === 'true' || value === true;
          break;
        default:
          val[index][field] = value;
      }
    },
    onSwitchChange(checked) {
      this.$emit('switch-change', checked);
    }
  }
};
</script>

<style scoped>
.field-separation {
  border-bottom: 1px solid #e5e5e5;
}
.is-inline-block {
  line-height: 1;
}
.control{
  width: 100%;
}
.buttons{
  display: flex;
  flex-direction: column;
  align-items: center;
}
.buttons .button{
  margin-right: 0;
}
.form  .dot{
  color: #D9D9D9;
}
span.icon.dot {
  font-size: 0.8rem;
}
.control .columns:last-child .column {
  display: flex;
}
@media only screen and (min-width: 769px){
  .form{
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .form:not(:last-child){
    margin-bottom: 2rem;
  }
}
@media only screen and (max-width: 768px){
  .form > *:not(:last-child){
    margin-bottom: 1rem;
  }
  .form:not(:last-child){
    padding-bottom: 1rem;
    border-bottom: 1px solid #dbdbdb;
    margin-bottom: 1.5rem;
  }
  .dot{
    display: none;
  }
}
</style>

<style>
.evaluation-field-container button {
  margin-top: -16px;
}
</style>
